import { useState, useEffect } from 'react';
import './scrollToTopButton.scss';

const ScrollToTopButton = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setVisible(window.scrollY > 300);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    if (!visible) {
        return null;
    }

    return (
        <button
            className="scroll-to-top-button"
            onClick={handleClick}
            aria-label="Back to top"
            title="Back to top"
            type="button"
        >
            ↑
        </button>
    );
};

export default ScrollToTopButton;